document.addEventListener('quick-view:loaded', function(event) {
  // Wait for DOM to be fully ready
  setTimeout(function() {
    // Try different ReCharge initialization methods
    if (typeof ReChargeWidget !== 'undefined' && ReChargeWidget.init) {
      ReChargeWidget.init();
    } else if (typeof ReCharge !== 'undefined' && ReCharge.init) {
      ReCharge.init();
    } else if (window.renderSubscriptionWidget) {
      window.renderSubscriptionWidget();
    }
    
    // Trigger any ReCharge events
    if (typeof ReChargeWidget !== 'undefined') {
      window.dispatchEvent(new Event('recharge:init'));
    }
  }, 100);
});